<template>
  <div class="row">
    <div class="col-12">
      <div class="tile">
        <div class="form-inline">
          <b-form-input class="mr-1 mb-1" v-model="filterFormModel.keyword" v-on:keydown.enter="load"
                        :placeholder="$t('keyword')"></b-form-input>
          <button @click="load" class="btn btn-primary mr-1 mb-1">{{ $t('search') }}</button>
          <button @click="reset" class="btn btn-secondary mr-1 mb-1">Reset</button>
        </div>
      </div>
    </div>
    <div class="col-12">
      <div class="c-paging clearfix">
        <div class="c-paging__count" v-if="itemCount">
          {{ $t('found', [itemCount]) }}
        </div>
        <div class="c-paging__right">
          <div class="c-paging__numbers">
            <b-pagination v-if="itemCount > filterFormModel.pageSize" class="pull-right" size="sm"
                          v-model="filterFormModel.page" :total-rows="itemCount"
                          :per-page="filterFormModel.pageSize" @input="load"></b-pagination>
          </div>
        </div>
      </div>
    </div>
    <div class="col-12" v-if="items.length">
      <div class="c-smart-table tile">
        <div class="row c-smart-table__title">
          <div class="col-lg-4">{{ $t('product') }}</div>
          <div class="col-lg-3">{{ $t('price') }}</div>
          <div class="col-lg-3">{{ $t('info') }}</div>
          <div class="col-lg-2"></div>
        </div>
        <div class="row" v-for="item in items" :key="item._id">
          <div class="col-lg-4">
            <div>
              <b>{{ $t('sku') }}: </b> <span>{{ item.sku }}</span>
            </div>
            <div>
              <b>{{ $t('name') }}: </b> <span>{{ item.name }}</span>
            </div>
            <div>
              <span class="badge badge-info mr-1">{{$t(item.type + 'Product')}}</span>
              <span class="badge badge-success" v-if="item.active">{{$t('activated')}}</span>
              <span class="badge badge-danger" v-else>{{$t('deactivated')}}</span>
            </div>
          </div>
          <div class="col-lg-3">
            <div>
              <b>{{ $t('importPrice') }}: </b> <span v-if="item.importPrice">{{ item.importPrice | numFormat }}đ</span>
              <span v-else class="text-secondary small">{{$t('notUpdated')}}</span>
            </div>
            <div>
              <b>{{ $t('listPrice') }}: </b> <span v-if="item.listPrice">{{ item.listPrice | numFormat }}đ</span>
              <span v-else class="text-secondary small">{{$t('notUpdated')}}</span>
            </div>
            <div>
              <b>{{ $t('sellPrice') }}: </b> <span v-if="item.sellPrice">{{ item.sellPrice | numFormat }}đ</span>
              <span v-else class="text-secondary small">{{$t('notUpdated')}}</span>
            </div>
          </div>
          <div class="col-lg-3">
            <div>
              <b>{{ $t('variant') }}: </b> <span>{{ item.childProductsCount }}</span>
            </div>
            <div>
              <b>{{ $t('createdBy') }}: </b> <span v-if="item.createdBy">{{ item.createdBy.name }}</span>
              <span v-else class="text-secondary small">{{$t('notUpdated')}}</span>
            </div>
            <div>
              <b>{{ $t('createTime') }}: </b> <span>{{ item.createTime | moment('DD/MM/YY HH:mm') }}đ</span>
            </div>
          </div>
          <div class="col-lg-2 text-center">
            <div class="c-smart-table__content">
              <div class="c-buttons clearfix is-2">
                <div class="c-buttons__col">
                  <button @click="update(item._id)" type="button"
                          class="btn btn-sm btn-info">
                    <font-awesome-icon icon="info"/>&nbsp;{{ $t('detail') }}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-12 text-center text-danger" v-if="!items.length">
      <span v-if="filterFormModel.page === 1 && !filterFormModel.keyword">{{ $t('notFoundCreate') }}</span>
      <span v-if="filterFormModel.page > 1 || filterFormModel.keyword">{{ $t('notFoundSearch') }}</span>
    </div>

    <div class="col-12" v-if="itemCount">
      <div class="c-paging__count" v-if="itemCount">
        {{ $t('found', [itemCount]) }}
      </div>
      <b-pagination v-if="itemCount > filterFormModel.pageSize" class="pull-right" size="sm"
                    v-model="filterFormModel.page" :total-rows="itemCount" :per-page="filterFormModel.pageSize"
                    @input="load">
      </b-pagination>
    </div>
    <b-modal size="lg" v-model="showForm" :title="$t('detail')" no-close-on-backdrop no-enforce-focus>
      <div>
        <b>{{ $t('type') }}: </b> <span>{{$t(formModel.type + 'Product')}}</span>
      </div>
      <div>
        <b>{{ $t('sku') }}: </b> <span>{{ formModel.sku }}</span>
      </div>
      <div>
        <b>{{ $t('name') }}: </b> <span>{{ formModel.name }}</span>
      </div>
      <div>
        <b>{{ $t('desc') }}: </b> <br>
        <div class="bg-light border desc-viewer p-2">
          <div v-html="formModel.desc"></div>
        </div>
      </div>
      <div class="mt-2" v-if="formModel.images && formModel.images.length">
        <a class="d-inline-block border mr-1 rounded" target="_blank"
           v-for="(image, index) in formModel.images" :key="index" :href="image.url"
        >
          <img height="100" width="100px" style="object-fit: contain" :src="image.url" />
        </a>
      </div>
      <hr class="invisible mt-1 mb-0">
      <div v-if="formModel.customFields && formModel.customFields.length">
        <hr class="my-2">
        <h5 class="mb-0">{{$t('customInfo')}}</h5>
        <ul class="mb-2">
          <li v-for="field in formModel.customFields" :key="field.key">
            <b>{{ field.key }}: </b> <span v-if="field.val">{{ field.val.join(', ') }}</span>
            <span v-else class="text-secondary small">{{ $t('notUpdated') }}</span>
          </li>
        </ul>
      </div>
      <div v-if="formModel.type === 'store'">
        <hr class="my-2">
        <h5 class="mb-0">{{$t('warehouse')}}</h5>
        <ul class="mb-2">
          <li>
            <b>{{ $t('warehouse') }}: </b> <span v-if="formModel.warehouse">{{ formModel.warehouse.name }}</span>
            <span v-else class="text-secondary small">{{ $t('notUpdated') }}</span>
          </li>
          <li>
            <b>{{ $t('quantity') }}: </b> <span v-if="formModel.quantity">{{ formModel.quantity | numFormat }}đ</span>
            <span v-else class="text-secondary small">{{ $t('notUpdated') }}</span>
          </li>
        </ul>
      </div>
      <div>
        <hr class="my-2">
        <h5 class="mb-0">{{$t('price')}}</h5>
        <ul>
          <li>
            <b>{{ $t('importPrice') }}: </b> <span v-if="formModel.importPrice">{{ formModel.importPrice | numFormat }}đ</span>
            <span v-else class="text-secondary small">{{ $t('notUpdated') }}</span>
          </li>
          <li>
            <b>{{ $t('listPrice') }}: </b> <span v-if="formModel.listPrice">{{ formModel.listPrice | numFormat }}đ</span>
            <span v-else class="text-secondary small">{{ $t('notUpdated') }}</span>
          </li>
          <li>
            <b>{{ $t('sellPrice') }}: </b> <span v-if="formModel.sellPrice">{{ formModel.sellPrice | numFormat }}đ</span>
            <span v-else class="text-secondary small">{{ $t('notUpdated') }}</span>
          </li>
        </ul>
      </div>
      <div v-if="formModel.attributes && formModel.attributes.length">
        <hr class="my-2">
        <h5 class="mb-0">{{$t('attribute')}}</h5>
        <ul>
          <li v-for="attribute in formModel.attributes" :key="attribute.key">
            <b>{{ attribute.label }}: </b> <span v-if="attribute.vals">{{ attribute.vals.join(', ') }}</span>
            <span v-else class="text-secondary small">{{ $t('notUpdated') }}</span>
          </li>
        </ul>
      </div>
      <div v-if="formModel.childProducts && formModel.childProducts.length">
        <hr class="my-2">
        <h5>{{$t('variant')}}</h5>
        <table class="table w-100">
          <thead>
          <th>{{$t('variantSku')}}</th>
          <th>{{$t('attribute')}}</th>
          <th>{{$t('importPrice')}}</th>
          <th>{{$t('listPrice')}}</th>
          <th>{{$t('sellPrice')}}</th>
          <th v-if="formModel.type === 'store'">{{$t('quantity')}}</th>
          </thead>
          <tbody>
          <tr v-for="product in formModel.childProducts" :key="product._id">
            <td>{{product.sku}}</td>
            <td>{{product.attributes.map(a => a.val).join(' - ')}}</td>
            <td>{{product.importPrice | numFormat}}đ</td>
            <td>{{product.listPrice | numFormat}}đ</td>
            <td>{{product.sellPrice | numFormat}}đ</td>
            <td v-if="formModel.type === 'store'">{{product.quantity | numFormat}}</td>
          </tr>
          </tbody>
        </table>
      </div>

    </b-modal>
  </div>
</template>

<script>
import List from "@/mixins/List";
import CRUD from "@/mixins/CRUD";

export default {
  props: ['client'],
  mixins: [List, CRUD],
  data: function () {
    return {
      autoLoad: true,
      service: '/product',
      defaultFilterFormModel: {
        client: this.client ? this.client._id : null
      }
    }
  },
  i18n: {
    messages: {
      en: {
        product: "Sản phẩm",
        sku: "Mã sản phẩm",
        name: "Tên sản phẩm",
        storeProduct: "Sản phẩm lưu kho",
        serviceProduct: "Sản phẩm dịch vụ",
        available: "Sản phẩm có sẵn",
        importPrice: "Giá nhập",
        listPrice: "Giá cũ",
        sellPrice: "Giá bán",
        variant: "Biến thể",
        warehouse: "Kho hàng",
        quantity: "Tồn đầu",
        createdBy: "Tạo bởi",
        customInfo: "Tuỳ biến",
        attribute: "Thuộc tính",
        variantSku: "Mã biến thể"
      },
      vi: {
        product: "Sản phẩm",
        sku: "Mã sản phẩm",
        name: "Tên sản phẩm",
        storeProduct: "Sản phẩm lưu kho",
        serviceProduct: "Sản phẩm dịch vụ",
        available: "Sản phẩm có sẵn",
        importPrice: "Giá nhập",
        listPrice: "Giá cũ",
        sellPrice: "Giá bán",
        variant: "Biến thể",
        warehouse: "Kho hàng",
        quantity: "Tồn đầu",
        createdBy: "Tạo bởi",
        customInfo: "Tuỳ biến",
        attribute: "Thuộc tính",
        variantSku: "Mã biến thể"
      }
    }
  }
};
</script>
<style>
.desc-viewer {
  min-height: 200px;
  max-height: 500px;
  overflow: auto;
}
</style>